export default "__VITE_ASSET__1MLfXP_L__"